// SprintsMain
/**
 * Main component for secured sprints section.
 * Checks if the user is logged in and has permission to view secured content.
 * Redirects unauthorized users or renders the secured search component via route.
 *
 * @component
 * @returns {JSX.Element} Rendered component for secured sprints management.
 */

import React, { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Routes, Route, useNavigate } from 'react-router-dom'
import { useStores } from '../../../cls/stores/MobXProvider'
import SecuredSearch from './SecuredSearch'
import { useSmartTranslation } from '../../../cls/TranslationContext'

const SprintsMain = () => {
	const navigate = useNavigate()
	const { users } = useStores()
	const { loggedInUserId, loggedInUser } = users
	const isAdmin = loggedInUser?.isAdmin
	const isSuperAdmin = loggedInUser?.isSuperAdmin
	const { t } = useSmartTranslation()

	useEffect(() => {
		if (!users.isLoggedIn) {
			navigate('/logout')
			return
		}
	}, [loggedInUserId])

	// If the user does not have personal permission
	// and lacks the required permissions for the action and resource
	// Display a message indicating lack of permissions
	if (!(isAdmin || isSuperAdmin || users.canUser('read', 'secured'))) {
		return (
			<div style={{ textAlign: 'center' }}>
				{t('__denied.access').charAt(0).toUpperCase() +
					t('__denied.access%__feature-off%single.secured.label')
						.toLowerCase()
						.slice(1)}
			</div>
		)
	}

	return (
		<Routes>
			<Route index element={<SecuredSearch />} />
			<Route path="*" element={<div>Not found</div>} />
		</Routes>
	)
}
export default observer(SprintsMain)
